module.exports = __webpack_public_path__ + "media/images/icons/twotone/close-square-fddcd67dccc558537127c97ce2d5c37e.svg";